import { handleActions } from 'redux-actions'
import * as rawActions from '../actions'

export default handleActions(
  {
    [rawActions.setAdminPermissionFlag](state, action) {
      return action.payload
    },
    [rawActions.resetState](state, action) {
      return false
    },
  },
  false
)
